'use strict';
import template from './listadoObservadosAnual.html';
import controller from './listadoObservadosAnual.controller';

const listadoObservadosAnualComponent = {
  controller,
  template
};

export default listadoObservadosAnualComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/lista-observadoAnual/listadoObservadosAnual.component.js